import styled from 'styled-components';
import { Avatar, Typography, Space } from 'antd';
import { colors, fonts, breakpoints } from '../../theme';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 100%;

  ${breakpoints.media.mobile} {
    gap: 12px;
  }
`;

export const StyledAvatar = styled(Avatar)`
  border: 3px solid ${colors.primary};
  border-radius: 10px;
  background: ${colors.black};

  ${breakpoints.media.mobile} {
    border-width: 2px;
  }

  .ant-avatar-image {
    object-fit: cover;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 150px;
  max-width: 350px;
  width: 100%;
`;

export const StyledTitle = styled(Typography.Title)`
  &.ant-typography {
    font-family: ${fonts.families.primary};
    font-size: ${fonts.sizes.lg};
    color: ${colors.white};
    margin: 0;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: ${fonts.letterSpacing.wide};
    font-weight: ${fonts.weights.normal};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;

    ${breakpoints.media.mobile} {
      font-size: ${fonts.sizes.md};
    }
  }
`;

export const StyledText = styled(Typography.Text)`
  &.ant-typography {
    font-family: ${fonts.families.secondary};
    font-size: ${fonts.sizes.sm};
    color: ${colors.whiteTransparent[80]};
    text-align: center;
    display: block;
    word-break: normal;
    overflow-wrap: break-word;
    white-space: normal;

    ${breakpoints.media.mobile} {
      font-size: ${fonts.sizes.xs};
    }
  }
`;

export const SocialMediaSpace = styled(Space)`
  margin-top: 4px;

  &.ant-space {
    gap: 12px;
  }

  ${breakpoints.media.mobile} {
    &.ant-space {
      gap: 8px;
    }
  }
`;
